import { render, staticRenderFns } from "./one-time-code-input.vue?vue&type=template&id=8fa7cf18"
import script from "./one-time-code-input.vue?vue&type=script&lang=js"
export * from "./one-time-code-input.vue?vue&type=script&lang=js"
import style0 from "./one-time-code-input.vue?vue&type=style&index=0&id=8fa7cf18&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports